import {
  clearUserAuthData,
} from "./authRefresh";
const config = require("../config");

const getUserLogoutUrl = () => {
  const { pathname, search } = window.location;
  const normalizedPathname = pathname.replace(/\/+$/, "") || "/";

  if (normalizedPathname === "/careers") return "/careers";
  if (normalizedPathname.startsWith("/careers/")) {
    return `/careers?continueTo=${pathname}${search}`;
  }

  if (normalizedPathname === "/consultant") return "/consultant";
  if (normalizedPathname.startsWith("/consultant/")) {
    return `/consultant?continueTo=${pathname}${search}`;
  }

  return `/?continueTo=${pathname}${search}`;
};

export const globalLogout = () => {
  clearUserAuthData();
  window.location.replace(getUserLogoutUrl());
};

export const setupInterceptors = (instance) => {
  instance.interceptors.request.use((configReq) => {
    const tokenType = configReq.tokenType || "user";
    const token = localStorage.getItem("user.token");
    const isApiRequest = !configReq.url.startsWith("http") || configReq.url.startsWith(config.api);
    
    if (tokenType === "user" && token && isApiRequest && !configReq.headers.Authorization) {
      configReq.headers.Authorization = `Bearer ${token}`;
    }
    return configReq;
  }, (error) => Promise.reject(error));

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const res = error?.response;
      const tokenType = originalRequest?.tokenType || "user";

      if (tokenType !== "user") {
        return Promise.reject(error);
      }

      // With local JWT (24h), a 401 means the session is genuinely invalid.
      // No need to try Keycloak refresh — just logout.
      // SSO session validation is handled separately via proactive refresh in isTokenValid.
      if (res?.status === 401 && originalRequest && !originalRequest._retry) {
        originalRequest._retry = true;
        globalLogout();
        return Promise.reject(error);
      }
      
      const errorMsg = res?.data?.error?.message || res?.data?.error || "";
      if (errorMsg.includes("jwt expired") || errorMsg.includes("jwt malformed") || res?.data?.status === 401) {
        globalLogout();
      }

      return Promise.reject(error);
    }
  );
};
